import React, { Component } from "react";
import { Container, Card } from "react-bootstrap";
import "./Home.css";
import Bannerimage from "./Bannerimage";

class Home extends Component {
  render() {
    return (
      <div>
        <div className="topbanner">
          <Bannerimage />
        </div>

        <div className="col-12" style={{ textAlign: "center" }}>
          <h3>BBM Universal improves your overall POS experience</h3>
          <p>BBM Universal is all about ACCURACY and SPEED</p>
        </div>
        <Container>
          <div className="row">
            <div className="col-sm-12 col-lg-6 card1">
              <h3>Point of sale and Touch Terminal</h3>
             <p>
                The point of sale ( Pos ) and Touch terminal is a system 
                where a retail transaction is completed. This system comes
                with a wide range of Pos applications and software such as
                latest window to touch screen widget interface that allowed 
                representing some menu items. 
             </p>
              
             <p>
                As Businesses have different profiles, they need various point
                of sales systems as well. For example, restaurants, retails,
                grocery stores and casino tables all have their specialties and
                that is why they need a Pos system that meets their specific
                needs.
             </p>
            </div>
            <div className="col-sm-12 col-lg-6 card2">
              <h3>Winning Number Display</h3>
              <p>
                The 29inch LCD display ( wnd ) possesses high resolution
                of roulette wheel which simulates real wheel behaviour and 
                players can keep an eye on the game state. Despite its 
                simplicity, this display possesses a quick recognition of 
                winning number, high performance 24/7 and easy 
                installation. 
              </p>
              
              <p>
                The smart pc under the casino table read the winning  
                numberjust in a second and immediately shows it on the led display.
              </p>
            </div>
          </div>
        </Container>

        <Container>
          <h3 className="header">featured Products</h3>
          <div className="row">
            <div className="col-sm-12 col-md-6 col-lg-3 prodcard">
              <Card>
                <Card.Img variant="top" src="assets/images/mini_prod01.jpg" />
                <Card.Body>
                  <Card.Title>Roulette Display</Card.Title>
                  {/* <Card.Text>none</Card.Text> */}
                </Card.Body>
              </Card>
            </div>
            <div className="col-sm-12 col-md-6 col-lg-3 prodcard">
              <Card>
                <Card.Img variant="top" src="assets/images/mini_prod02.jpg" />
                <Card.Body>
                  <Card.Title>Digital Signage</Card.Title>
                  {/* <Card.Text>none</Card.Text> */}
                </Card.Body>
              </Card>
            </div>
            <div className="col-sm-12 col-md-6 col-lg-3 prodcard">
              <Card>
                <Card.Img variant="top" src="assets/images/mini_prod03.jpg" />
                <Card.Body>
                  <Card.Title>Mini Receipt printer</Card.Title>
                  {/* <Card.Text>none</Card.Text> */}
                </Card.Body>
              </Card>
            </div>
            <div className="col-sm-12 col-md-6 col-lg-3 prodcard">
              <Card>
                <Card.Img variant="top" src="assets/images/mini_prod04.jpg" />
                <Card.Body>
                  <Card.Title>Point of Sale</Card.Title>
                  {/* <Card.Text>none</Card.Text> */}
                </Card.Body>
              </Card>
            </div>
          </div>
        </Container>

        <div className="parallax_home slogan">
          <img
            className="slogan_logo"
            src="./assets/images/logo.svg"
            alt="logo"
          />
          <h1>BBM UNIVERSAL “YOUR SUCCESS IS OUR VISON“</h1>
        </div>

        <div
          style={{
            // height: "300px"
            // "background-color": "red"
            marginTop: "50px"
          }}
        >
          <Container>
            <h3>Contact us for a demo</h3>

            <p>info@bbmuniversal.co.za</p>
            <p>call +27 (0)61 967 9859</p>
          </Container>
        </div>
      </div>
    );
  }
}

export default Home;
